import { render } from "./ValidationErrors.vue?vue&type=template&id=4f3624e2"
import script from "./ValidationErrors.vue?vue&type=script&lang=js"
export * from "./ValidationErrors.vue?vue&type=script&lang=js"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ValidationErrors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f3624e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f3624e2', __exports__)) {
    console.log('reload')
    api.reload('4f3624e2', __exports__)
  }
  
  module.hot.accept("./ValidationErrors.vue?vue&type=template&id=4f3624e2", () => {
    console.log('re-render')
    api.rerender('4f3624e2', render)
  })

}


export default __exports__